import Grid from '@mui/material/Grid2'
import { AppBtn } from '../components/AppBtn'
import { Footer } from '../components/Footer'
import useRole from '../hooks/useRole'

export const Apps = () => {
	const { canManageUsers, canCreateUser, canRead } = useRole()

	const allApps = [
		{
			name: 'Administrar Usuarios',
			icon: '/assets/users.png',
			url: 'administrar-usuarios',
			requiredPermission: 'canManageUsers'
		},
		{
			name: 'Crear Usuario',
			icon: '/assets/add-user.png',
			url: 'crear-usuario',
			requiredPermission: 'canCreateUser'
		},
		{
			name: 'Administrar Datos',
			icon: '/assets/data-management.png',
			url: 'administrar-datos',
			requiredPermission: 'canRead'
		},
		{
			name: 'Crear Lote',
			icon: '/assets/document.png',
			url: 'crear-lote',
			requiredPermission: 'canRead'
		},
		{
			name: 'Administrar Lotes',
			icon: '/assets/add-file.png',
			url: 'administrar-lotes',
			requiredPermission: 'canRead'
		},
		{
			name: 'Inventario',
			icon: '/assets/inventory.png',
			url: 'inventario',
			requiredPermission: 'canRead'
		},
		{
			name: 'Historial de Movimientos',
			icon: '/assets/document.png',
			url: 'historial-movimientos',
			requiredPermission: 'canRead'
		},
		{
			name: 'Historial de Pruebas',
			icon: '/assets/test.png',
			url: 'historial-pruebas',
			requiredPermission: 'canRead'
		}
	]

	// Filtrar apps basado en permisos
	const getPermissionValue = (permission: string) => {
		switch (permission) {
			case 'canManageUsers':
				return canManageUsers()
			case 'canCreateUser':
				return canCreateUser()
			case 'canRead':
				return canRead()
			default:
				return false
		}
	}

	const apps = allApps.filter(app => getPermissionValue(app.requiredPermission))

	return (
		<>
			<Grid
				container
				justifyContent="center"
				alignItems="center"
				minHeight={'50vh'}
				paddingY={10}
				sx={{
					overflowX: 'hidden',
					overflowY: 'auto'
				}}
			>
				{apps.map((app, index) => (
					<Grid
						display={'flex'}
						alignItems={'center'}
						justifyContent={'center'}
						key={app.name}
						size={{ xs: 6, sm: 4, md: 4, lg: 2, xl: 2 }}
					>
						<AppBtn name={app.name} icon={app.icon} url={app.url} index={index + 1} />
					</Grid>
				))}
			</Grid>
			<Footer />
		</>
	)
}
